/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Feature used to lock some functionality
 * @export
 * @interface ApiFeature
 */
export interface ApiFeature {
    /**
     * 
     * @type {number}
     * @memberof ApiFeature
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiFeature
     */
    organisationId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiFeature
     */
    feature: string;
}

/**
 * Check if a given object implements the ApiFeature interface.
 */
export function instanceOfApiFeature(value: object): value is ApiFeature {
    if (!('feature' in value) || value['feature'] === undefined) return false;
    return true;
}

export function ApiFeatureFromJSON(json: any): ApiFeature {
    return ApiFeatureFromJSONTyped(json, false);
}

export function ApiFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organisationId': json['organisationId'] == null ? undefined : json['organisationId'],
        'feature': json['feature'],
    };
}

export function ApiFeatureToJSON(json: any): ApiFeature {
    return ApiFeatureToJSONTyped(json, false);
}

export function ApiFeatureToJSONTyped(value?: ApiFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organisationId': value['organisationId'],
        'feature': value['feature'],
    };
}

